export default __webpack_public_path__ + "static/media/facebook.171eb4d5.svg";